<template>
  <div role="tablist" class="collapse-icon" :class="collapseClasses">
    <b-card
      no-body
      :class="[{ open: visible }, { 'card-none': !isShadow }]"
      @mouseenter="collapseOpen"
      @mouseleave="collapseClose"
    >
      <b-card-header
        :class="[
          { collapsed: !visible },
          { 'card-header-left': !isHeaderPaddingLeft },
        ]"
        :aria-expanded="visible.toString()"
        :aria-controls="collapseItemID"
        role="tab"
        data-toggle="collapse"
        @click="updateVisible(!visible)"
      >
        <slot name="header" />
      </b-card-header>

      <b-collapse
        :id="collapseItemID"
        v-model="visible"
        :accordion="accordion"
        role="tabpanel"
      >
        <slot />
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCollapse } from "bootstrap-vue"
import { v4 as uuidv4 } from "uuid"

export default {
  components: {
    BCard,
    BCardHeader,
    BCollapse,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    isShadow: {
      type: Boolean,
      required: false,
      default: true,
    },
    isHeaderPaddingLeft: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      collapseID: "",

      visible: false,
      collapseItemID: "",
      openOnHover: this.$parent.hover,
    }
  },
  computed: {
    collapseClasses() {
      const classes = []

      // Collapse Type
      const collapseVariants = {
        default: "collapse-default",
        border: "collapse-border",
        shadow: "collapse-shadow",
        margin: "collapse-margin",
      }
      classes.push(collapseVariants[this.type])

      return classes
    },
    accordion() {
      return this.$parent.accordion
        ? `accordion-${this.$parent.collapseID}`
        : null
    },
  },
  created() {
    this.collapseID = uuidv4()
    this.collapseItemID = uuidv4()
    this.visible = this.isVisible
  },
  methods: {
    updateVisible(val = true) {
      this.visible = val
      this.$emit("visible", val)
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true)
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false)
    },
  },
}
</script>

<style scoped>
.card-none {
  box-shadow: none;
}
.card-header-left {
  padding-left: 0 !important;
}
</style>
